import { makeStyles } from '@material-ui/core/styles'

export const profileSettingsStyle = makeStyles((theme) => ({
  root: {
    display: 'flex',
    width: '100%'
  },
  setting: {
    display: 'flex',
    flexDirection: 'column',
    minWidth: 150,
    marginRight: theme.spacing(4)
  },
  viewLabel: {
    display: 'flex',
    margin: 0,
    marginRight: theme.spacing(2),
    fontSize: '0.7rem',
    alignSelf: 'left',
    whiteSpace: 'nowrap',
    color: theme.palette.geoColors.toolBar.main,
    height: 15
  },
  viewButton: {
    width: 30,
    height: 40
  },
  viewSettings: {
    padding: theme.spacing(1),
    fontSize: '0.8rem'
  },
  viewSettingsDescription: {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  },
  viewSettingsLabel: {
    width: '100%',
    height: 35,
    marginLeft: 0,
    '& .MuiTypography-root': {
      fontSize: '0.8rem'
    }
  },
  spacer: {
    width: '100%'
  },
  toolIcon: {
    paddingTop: theme.spacing(1),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(1.5),
    width: 35
  }
}))
